import React, { useState } from "react";
import styles from './RegisterWhatsAppNumber.module.css'
import { BASE_URL_API } from '../../../References/URLs'
import { toast } from 'react-toastify'
import { useContext } from 'react'
import AuthContext from '../../../store/auth-context'
import ActiveStoreContext from '../../../store/ActiveStoreContext'


const RegisterWhatsAppNumber = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const [phoneNumberId, setPhoneNumberId] = useState("");
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [status, setStatus] = useState(null);

    const handleRegister = async (e) => {
        e.preventDefault();

        if (!phoneNumberId) {
            setStatus("error");
            setResponseMessage("Please enter Phone Number ID");
            return;
        }

        try {
            setLoading(true);
            setStatus(null);
            setResponseMessage("");

            const response = await fetch(`${BASE_URL_API}registerWhatsAppNumberViaCloudAPI`, {
                method: "POST",
                body: JSON.stringify({ 
                    token: authCtx.token,
                    storeId: activeStore?.id,
                    phoneNumberId: phoneNumberId
                })
            });

            const responseData = await response.json();

            if (responseData.status === "success") {
                setStatus("success");
                setResponseMessage(responseData.message);
            } else {
                if (responseData.message==="tokenExpired") {
                    authCtx.logout();
                    toast.error("Session expired. Please log in again.");
                    return;
                }
                setStatus("error");
                setResponseMessage(responseData.message);
            }

        } catch (error) {
            setStatus("error");
            setResponseMessage(
                error.response?.data?.message || "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <h2>Register WhatsApp Number (Cloud API)</h2>

            <form onSubmit={handleRegister}>
                <input
                    type="text"
                    placeholder="Enter Phone Number ID"
                    value={phoneNumberId}
                    onChange={(e) => setPhoneNumberId(e.target.value)}
                    className={styles.input}
                />

                <button type="submit" disabled={loading} className={styles.button}>
                    {loading ? "Registering..." : "Register Number"}
                </button>
            </form>

            {responseMessage && (
                <div
                    
                >
                    {responseMessage}
                </div>
            )}
        </div>
    );
};



export default RegisterWhatsAppNumber;
